export function onKey(binding, onTrigger, options = {}) {
  return { binding, onTrigger, ...options };
}
